import React, { Component, Fragment } from 'react'
import moment from 'moment'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'

export const PasajeroLectura = (props) => {
    const {p, i, downloadFile, asistencia_vajero} = props
    
    const fileid = p.getIn(['adjunto', 'id']) ? p.getIn(['adjunto', 'id']) : null
    const filename = p.getIn(['adjunto', 'nombre']) ? p.getIn(['adjunto', 'nombre']) : null

    const fecha_salida = moment(p.getIn(['asistencia', 'fecha_salida']))

    const fecha_regreso = moment(p.getIn(['asistencia', 'fecha_regreso']))

    const totalDias = Math.abs(fecha_regreso.diff(fecha_salida, 'days'))
    
    return ( 
        
        <Fragment>

            <div className="separator"></div>
            
            <Box title={ `Pasajero #${i+1}` }>
            
                <Box title={ 'Información del pasajero' } onModal>

                    <div className="separator"></div>
                
                    <div className="row">

                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Tipo pasajero</label>
                                <select className="form-control input-sm" value={p.get('tipo_pasajero') || ''} disabled>
                                    <option value="1">Empleado</option>
                                    <option value="2">Invitado</option>
                                </select>
                            </div>
                        </div>
                        
                            
                        <div className="col-md-4">
                            <div className="form-group">
                                <label className="control-label">Nombres</label>
                                <input className="form-control input-sm" type="text" value={ p.get('nombres') || '' } disabled />
                            </div>
                        </div>
                        
                        <div className="col-md-4">
                            <div className="form-group">
                                <label className="control-label">Apellidos</label>
                                <input className="form-control input-sm" type="text" value={ p.get('apellidos') || '' } disabled />
                            </div>
                        </div>
                        
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Cédula</label>
                                <input className="form-control input-sm" type="text" value={ p.get('cedula') || '' } disabled />
                            </div>
                        </div>
                        
                    </div>
                    
                    
                    <div className="row">
                    
                    
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Celular</label>
                                <input className="form-control input-sm" type="text" value={ p.get('celular') || '' } disabled />
                            </div>
                        </div>
                        
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Correo</label>
                                <input className="form-control input-sm" type="text" value={ p.get('correo') || '' } disabled />
                            </div>
                        </div> 
                        
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Fecha nacimiento</label>
                                <input className="form-control input-sm" type="text" value={ moment(p.get('fecha_nacimiento')).format('DD/MM/YYYY') || '' }  disabled />
                            </div>
                        </div>
                        
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Nacionalidad</label>
                                <input className="form-control input-sm" type="text" value={ p.get('nacionalidad') || '' } disabled />
                            </div>
                        </div>
                    
                    </div>                       
                    
                    
                    
                    <div className="row">
                    
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">No. Pasaporte</label>
                                <input className="form-control input-sm" type="text" value={ p.get('pasaporte') || '' } disabled/>
                            </div>
                        </div>
                        
                        
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">País expedición</label>
                                <input className="form-control input-sm" type="text" value={ p.get('pais_expedicion') || '' } disabled />
                            </div>
                        </div>
                        
                        
                        <div className="col-md-3">
                            <div className="form-group">
                                <label className="control-label">Fecha caducidad pasaporte</label>
                                <input className="form-control input-sm" type="text" value={ moment(p.get('fecha_caducidad_pasaporte')).format('DD/MM/YYYY') != 'Invalid date' ? moment(p.get('fecha_caducidad_pasaporte')).format('DD/MM/YYYY') : '' } disabled />
                            </div>
                        </div> 
                        
                        
                        <div className="col-md-3">                                            
                            <div className="form-group">                                                
                                <label className="control-label">
                                    Descargar pasaporte
                                </label>
                                <label 
                                    className={`form-control input-sm label-upload-file ${(p.get('pasaporte_adjunto')) ? 'label-upload-file-enabled': 'label-upload-file-disabled' }`} 
                                    onClick={ (p.get('pasaporte_adjunto')) ? () => downloadFile(fileid, filename) : () => null }  
                                >
                                    <i className="fa fa-download"></i> { p.get('pasaporte_adjunto') ? filename : '' }
                                </label>
                            </div>
                        </div>                                
                    </div>                                     
                </Box>

                {
                    (asistencia_vajero) && (
                        <Fragment>

                            <div className="separator"></div> 

                            <Box title={ 'Información asistencia de viaje' } onModal>

                                <div className="separator"></div>

                                <div className="row">

                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label className="control-label">País destino</label>
                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'pais_destino']) || '' } disabled />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Fecha salida</label>
                                            <input className="form-control input-sm" type="date" value={ fecha_salida.format('YYYY-MM-DD') || '' } disabled />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Fecha regreso</label>
                                            <input className="form-control input-sm" type="date" value={ fecha_regreso.format('YYYY-MM-DD') || ''  } disabled  />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Total días</label>
                                            <input className="form-control input-sm" type="text" value={ totalDias || 0 }  disabled />
                                        </div>
                                    </div>                                                
                                
                                </div>                                        
                            
                            </Box>

                            <div className="separator"></div>

                            <Box title={ 'En caso de emergencia avisar a:' } onModal>

                                <div className="separator"></div>

                                <div className="row">

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Nombres y apellidos</label>
                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'avisar_a']) || '' }  disabled />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <label className="control-label">Dirección</label>
                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'direccion']) || '' }  disabled  />
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Ciudad</label>
                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'ciudad']) || '' }  disabled  />
                                        </div>
                                    </div>


                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Celular</label>
                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'celular']) || '' }  disabled  />
                                        </div>
                                    </div>


                                    <div className="col-md-2">
                                        <div className="form-group">
                                            <label className="control-label">Teléfono</label>
                                            <input className="form-control input-sm" type="text" value={ p.getIn(['asistencia', 'telefono']) || '' }  disabled />
                                        </div>
                                    </div>
                                
                                </div>
                            
                            </Box>

                        </Fragment>
                    )
                }
            </Box>
        </Fragment>
            
    )
}


// WEBPACK FOOTER //
// ./src/components/TiquetesAereos/PasajeroLectura.jsx